import './OpenPositions.scss';

class OpenPositions {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['OpenPositions'] = OpenPositions;
export default OpenPositions;
